import { useLocation } from 'react-router-dom';
import SingleMaterialCard from '../SingleMaterialCard/SingleMaterialCard';
import SubjectHeader from '../SubjectHeader/SubjectHeader';
import './MaterialList.scss';
import { useLazyQuery } from '@apollo/client';
import { DEFAULT_EBOOKS_TYPES, GET_MATERIAL_LIST } from './api/MaterialListQuery';
import { useEffect, useState } from 'react';
import ToasterWithMessage from '../toaster';
import Loader from '../Loader/Loader';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, MATERIALS_TEXT, MYLIBRARY_TEXTS, QUESTION_BANK_TEXT, SCHOOL_ADMIN, STUDENT_ROLE } from '../../utils/constants';
import { useAppDispatch, useAppSelector } from '../../redux/app/hooks';
import { GET_CLASSROOM_UPDATES } from '../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { EbookNode, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables } from '../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom';
import { setTabIndication } from '../../redux/slices/indication';

interface MaterialType {
  typeName: string;
  navigateLocation: string;
}

const MaterialList = () => {
  const { state } = useLocation();
  const [materialsList, setMaterialsList] = useState<MaterialType[]>();
  const role = useAppSelector((state) => state.auth.role);
  const selectedLibraryId = localStorage.getItem('selectedLId');
  const { error } = ToasterWithMessage();
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const selectedSubject = useAppSelector((state) =>state.dashboard.selectedSubjectId)
  const [ebookNodes, setEbookNodes] = useState<EbookNode[]>([]);
  const dispatch = useAppDispatch();


  const [getMaterialList, { loading }] = useLazyQuery(GET_MATERIAL_LIST, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      const updatedMaterialsList = data?.getEbookTypes?.nodes.map((material: any) => {
        if (material.typeName === MATERIALS_TEXT) {
          return {
            ...material,
            navigateLocation: role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials/teaching-materials" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials/learning-materials' : '/teacher-classroom/ebooks/materials/teaching-materials',
          };
        } else if (material.typeName === QUESTION_BANK_TEXT) {
          return {
            ...material,
            navigateLocation: role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials/question-bank" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials/question-bank' : '/teacher-classroom/ebooks/materials/question-bank',
          };
        } else if (material.typeName === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT) {
          return {
            ...material,
            navigateLocation: role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials/examination-guide" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials/examination-guide' : '/teacher-classroom/ebooks/materials/examination-guide',
          };
        }
        return material;
      });
      setMaterialsList(updatedMaterialsList);
    },
    onError: (err: any) => {
      error(err?.message);
    }
  });
  
  useEffect(() => {
    if(role !== SCHOOL_ADMIN){
    getMaterialList({
      variables: {
        lId: selectedLibraryId
      }
    })
  }else{
    const updatedMaterialsList = DEFAULT_EBOOKS_TYPES.data?.getEbookTypes?.nodes.map((material: any) => {
        if (material.typeName === MATERIALS_TEXT) {
          return {
            ...material,
            navigateLocation: role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials/teaching-materials" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials/learning-materials' : '/teacher-classroom/ebooks/materials/teaching-materials',
          };
        } else if (material.typeName === QUESTION_BANK_TEXT) {
          return {
            ...material,
            navigateLocation: role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials/question-bank" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials/question-bank' : '/teacher-classroom/ebooks/materials/question-bank',
          };
        } else if (material.typeName === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT) {
          return {
            ...material,
            navigateLocation: role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks/materials/examination-guide" : role === STUDENT_ROLE ? '/student-classroom/ebooks/materials/examination-guide' : '/teacher-classroom/ebooks/materials/examination-guide',
          };
        }
        return material;
      });
      setMaterialsList(updatedMaterialsList);
  }
  }, []);

  

  const [getClassRoomUpdates] = useLazyQuery<
  GetClassroomUpdatesResponse,
  GetClassroomUpdatesVariables
>(GET_CLASSROOM_UPDATES,{
  fetchPolicy: FETCH_POLICY,
  onCompleted: (data) => {
   const { quiz, assignments, mylibrary, ebooks } = data.getClassroomUpdates;
   const quizCount = quiz.totalCount;
   const assignmentCount = assignments.totalCount;
   const myLibrayCount = mylibrary.totalCount
   const ebooksCount = ebooks.totalCount;
   const hasQuiz = quizCount > 0;
   const hasAssignment = assignmentCount > 0;
   const hasMylibrary =  myLibrayCount > 0;
   const hasEbooks = ebooksCount > 0;
 
   // Set tab indication based on either quiz or assignment presence
   dispatch(setTabIndication(hasQuiz || hasAssignment || hasMylibrary || hasEbooks));
   setEbookNodes(ebooks.nodes)
 },
  onError: (err) =>{
    error(err?.message);
  }
});

useEffect(()=>{
  if(role === STUDENT_ROLE && selectedClassRoomId) {
    getClassRoomUpdates({
      variables :{
        cId : selectedClassRoomId ?? ''
      }
    })
  }
},[selectedClassRoomId])

const isActive = (materialName : string) => {
  const subject  = ebookNodes.find(node => node.subjectId === selectedSubject);
  return subject ? subject.typeNames.includes(materialName) : false;
}

  return (
    <div className='materialListMainContainer'>
      <SubjectHeader headerName={state.title} backgroundColor={state?.backGroundColor} headerImage={state.imageSrc} backNavigation={{ path: role === SCHOOL_ADMIN ? "/admin-materials-upload/materials/ebooks": role === STUDENT_ROLE ? "/student-classroom/ebooks" : '/teacher-classroom/ebooks', state: { title: "E-Books" } }} />
      {       
        ((materialsList === undefined) || (loading)) ? <Loader bottom='180px' />
          :
          <div className='materialsListContainer'>
            {
              materialsList && materialsList?.length > 0 ?
                (
                  materialsList?.map((material: MaterialType, index: number) => (
                    <SingleMaterialCard material={material.typeName} keyValue={`${material?.typeName}-${index}`} navigateLocation={material?.navigateLocation} state={state} active={isActive(material.typeName)}/>
                  ))
                )
                : 
                <div className='noDataFoundStyle'>No data found</div>
            }
          </div>
      }
    </div>
  )
}

export default MaterialList;
